/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Style_Guide_Required_ErrorInputs */

const en_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style guide data is required`)
};

const fr_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnees de guide de style requises`)
};

const de_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styleguide-Daten erforderlich`)
};

const it_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono richiesti i dati della guida di stile`)
};

const ru_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необходимы данные руководства по стилю.`)
};

const es_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requieren datos de la guía de estilo`)
};

const zh_cn2_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要提供样式指南数据。`)
};

const ja_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドデータが必要です`)
};

const hi_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड डेटा आवश्यक है`)
};

const pt_pt2_iframe_remote_style_guide_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São necessários dados do guia de estilo.`)
};

/**
* | output |
* | --- |
* | "Style guide data is required" |
*
* @param {Iframe_Remote_Style_Guide_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_required_error = /** @type {((inputs?: Iframe_Remote_Style_Guide_Required_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Required_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_style_guide_required_error(inputs)
	if (locale === "de") return de_iframe_remote_style_guide_required_error(inputs)
	if (locale === "it") return it_iframe_remote_style_guide_required_error(inputs)
	if (locale === "ru") return ru_iframe_remote_style_guide_required_error(inputs)
	if (locale === "es") return es_iframe_remote_style_guide_required_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_style_guide_required_error(inputs)
	if (locale === "ja") return ja_iframe_remote_style_guide_required_error(inputs)
	if (locale === "hi") return hi_iframe_remote_style_guide_required_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_style_guide_required_error(inputs)
	return en_iframe_remote_style_guide_required_error(inputs)
});